// @flow

export const NAVIGATION_NAMES = {
  activity: 'Activity',
  announcements: 'Announcements',
  announcementNew: 'New Announcement',
  conversations: 'My Conversations',
  detailEvent: 'Detail Event',
  dashboard: 'Dashboard',
  documentation: 'Documentation',
  groupDetail: 'Group Detail',
  groups: 'Groups',
  memberDetail: 'Member Detail',
  memberDetailGeneralTab: 'Member Detail',
  memberDetailActivityTab: 'Activity',
  memberDetailHabitScheduleTab: 'Healthy Habits',
  memberDetailSessionDocTab: 'Documentation',
  members: 'Members',
  newEvent: 'New Event',
  newNote: 'New Note',
  notes: 'Notes',
  programsAndGroups: 'Programs and Groups',
  calendar: 'My Calendar',
  staff: 'Staff',
  staffDetail: 'Staff Detail',
  stories: 'Stories',
  storyNew: 'New Story',
  storyEdit: 'Edit Story',
  resources: 'Resources',
  resourcesAll: 'All Resources',
  savedResources: 'Saved Resources',
  signals: 'Signals',
};

export const NAVIGATION_ICONS = {
  activity: 'GraphUp',
  announcements: 'Megaphone',
  conversations: 'MultiBubble',
  detailEvent: 'Calendar',
  dashboard: 'ReportColumns',
  documentation: 'Notes',
  groupDetail: 'Group',
  groups: 'Group',
  memberDetail: 'User',
  memberDetailGeneralTab: 'User',
  memberDetailActivityTab: '',
  memberDetailHabitScheduleTab: 'Calendar',
  memberDetailSessionDocTab: 'Calendar',
  members: 'User',
  newEvent: 'CalendarPlus',
  calendar: 'Calendar',
  staff: 'Community',
  staffDetail: 'Community',
  stories: 'BookmarkBook',
  storyNew: 'BookmarkBook',
  storyEdit: 'BookmarkBook',
  resources: 'Suggestion',
  resourcesAll: 'Suggestion',
  savedResources: 'Suggestion',
  emr: 'PathfinderLeaf',
  signals: 'AntennaSignal',
};

export const PRIMARY_NAVIGATION_ORDER = [
  [
    'dashboard',
    'signals',
    'announcements',
    'conversations',
    'calendar',
    'resources',
    'stories',
    'documentation',
    'activity',
  ],
  ['members', 'groups', 'staff'],
  ['emr'],
];
